// React
import React from 'react';
import {
  Card,
  CardBody,
  CardFooter,
  Col,
  Form,
  Input,
  Label,
  Row,
} from 'reactstrap';

// Containers Injection
import {
  convertEventSelectToTarget,
  PageWrapper,
  SelectInput,
  SelectInputWithSearchApi,
} from '../../containers/componentsInjection';
import { createData } from '../../../../utils/createData';

export const ProposalsByCredentialsNTPage = ({
  history,
  validation,
  specialties,
}) => {
  return (
    <PageWrapper title="Rede Credenciada">
      <Row>
        <Col xxl={12}>
          <Card>
            <Form
              autoComplete="off"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <CardBody className="p-4">
                <Row>
                  <Col md={4}>
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="cityInput">
                        Cidade
                      </Label>
                      <SelectInputWithSearchApi
                        validation={validation}
                        invalid={
                          !!(
                            validation.touched.cityInput &&
                            validation.errors.cityInput
                          )
                        }
                      />
                    </div>
                  </Col>

                  <Col md={4}>
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="neighborhood">
                        Bairro
                      </Label>
                      <Input
                        type="text"
                        id="neighborhood"
                        name="neighborhood"
                        className="form-control"
                        placeholder="Digite o bairro"
                        onBlur={validation.handleBlur}
                        onChange={validation.handleChange}
                        value={validation.values.neighborhood}
                      />
                    </div>
                  </Col>

                  <Col md={4}>
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="company">
                        Empresa
                      </Label>
                      <Input
                        type="text"
                        id="company"
                        name="company"
                        className="form-control"
                        placeholder="Digite o nome da empresa"
                        onBlur={validation.handleBlur}
                        onChange={validation.handleChange}
                        value={validation.values.company}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col md={4}>
                    <div className="mb-3">
                      <Label htmlFor="specialties" className="form-label">
                        Especialidades
                      </Label>
                      <SelectInput
                        multiple={true}
                        className="form-control"
                        inputId="specialties"
                        value={validation.values.specialties}
                        onChange={(eventInput) => {
                          validation.handleChange(
                            convertEventSelectToTarget(
                              'specialties',
                              eventInput
                            )
                          );
                        }}
                        onBlur={(eventInput) => {
                          validation.handleBlur(
                            convertEventSelectToTarget(
                              'specialties',
                              eventInput
                            )
                          );
                        }}
                        options={createData(specialties) || []}
                        placeholder="Especialidades"
                      />
                    </div>
                  </Col>
                </Row>
              </CardBody>

              <CardFooter>
                <Col md={12}>
                  <div className="text-end d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-link me-3"
                      onClick={() => {
                        history.push('/relatorios');
                      }}
                    >
                      Voltar
                    </button>
                    <button type="submit" className="btn btn-primary ">
                      Gerar Relatório
                    </button>
                  </div>
                </Col>
              </CardFooter>
            </Form>
          </Card>
        </Col>
      </Row>
    </PageWrapper>
  );
};
